import { AproeProjectForm } from "./models";
import * as Fields from "./fieldNames";
import defaultUndefinedEnum from "../../../functions/defaultUndefinedEnum.function";
import formatDateWithOffset from "../../../functions/formatDateWithOffset.function";
import TestRequestProjectInfoRq from "../../../api/models/test-request/TestRequestProjectInfoRQ";

export default function mapToUpdateRequest(formularData: AproeProjectForm): TestRequestProjectInfoRq {
  return {
    [Fields.AWAITING_FEEDBACK]: formularData[Fields.AWAITING_FEEDBACK],
    [Fields.COMPLEXITY]: defaultUndefinedEnum(formularData[Fields.COMPLEXITY], undefined),
    [Fields.FINISHING_DATE]: formularData[Fields.FINISHING_DATE] || "",
    [Fields.SOLUTION_TYPE]: defaultUndefinedEnum(formularData[Fields.SOLUTION_TYPE], undefined),
    [Fields.TAPE_USED]: defaultUndefinedEnum(formularData[Fields.TAPE_USED], undefined),
    [Fields.SUPPORT_TYPE]: defaultUndefinedEnum(formularData[Fields.SUPPORT_TYPE], undefined),
  };
}
